import * as React from "react";
import { SectionContainer } from "../layout";
import { Link } from "../atoms/Link";
import { darkBackgroundColor } from "../../constants";
import { Button } from "../atoms/Button";

export const Faq = ({
  title,
  faqs,
  moreButton,
  backgroundColor = darkBackgroundColor,
}) => {
  return (
    <SectionContainer className={backgroundColor} title={title}>
      <div className="max-w-7xl mx-auto">
        <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12 lg:grid-cols-3">
          {faqs?.map((faq, index) => (
            <div key={index}>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                {faq.question}
              </h3>
              <p className="mt-2 text-base text-gray-500">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
      {moreButton?.text && moreButton?.href && (
          <Button className="mt-12" {...moreButton} />
      )}
    </SectionContainer>
  );
};
